module.exports = "http://localhost:4567/assets/fonts/7d5d1f2b6c36082160d900d6c9bd0635.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 800
// module chunks = 4